/**
 * Created by xueyh on 2017/6/29. for 缩减EMapLayer行数长度，减少圈复杂度；还需要增加可读性
 */
'use strict';
define([
    '../utils/CommonUtil',
    '../utils/LoggerUtil',
    '../g2'
], function (
    CommonUtil,
    LoggerUtil,
    g2
) {
    var extend ={
        //符号相关内部方法集合
        includeGetSymbol:function(component){
            component.include({
                _getSymbol_Zoom:function(zoom){
                    if(isNaN(zoom)){//默认级别
                        zoom=this.map.getZoomLevel();
                    };
                    return zoom;
                },
                _getSymbol_DataObj:function(dataObj,attributeField){
                    if(attributeField){
                        return dataObj[this.options.attributeField];
                    }
                    return undefined;
                },
                _getDataOrData2:function(data,data2){
                    if(data==undefined){return data2};
                    return data;
                },
                _getSymbol_symKeyLookstr:function(symKey,strLookfor){
                    if(symKey.endsWith(strLookfor)){
                        symKey=symKey.substr(0,symKey.length-3);//??????缺注释
                    }
                    return symKey;
                },
                //根据数据获取对应字段值的渲染符号key值对象
                _getSymbol_symKeyObj:function(renderFields,data) {
                    var i = 0, len = renderFields.length,
                        symKey = '', j = 0, len1, rangeStr;
                    for (; i < len; i++) {
                        var field = renderFields[i];
                        if (field) {
                            var dVal = data[field.field],
                                values = field.values;
                            if (values) {
                                len1 = values.length;
                                for (j = 0, rangeStr = null; j < len1; j++) {
                                    rangeStr = values[j];
                                    if (CommonUtil.assertWithin(dVal, rangeStr)) {
                                        break;
                                    }
                                }
                                if (rangeStr) {
                                    symKey += field.field + '$=$' + values[j] + '$_$';
                                }
                            }
                        }
                    }
                    return {'symKey':symKey,'rangeStr':rangeStr}
                } ,

                /***
                 * 根据key值获取符号配置
                 * @private
                 */
                _getSymbolObjByKey:function(symbolKey){
                    var k=0,len=this.allSymbols.length;
                    for(;k<len;k++){
                        var symbolObj=this.allSymbols[k];
                        if(symbolObj){
                            if(symbolObj.symbolKey==symbolKey){
                                return symbolObj;
                            }
                        }
                    }
                    return null;
                },
                /***
                 * 根据数据和配置项获取简单或者符合符号
                 * @param data
                 * @param config
                 * @param defaultSymbol
                 * @returns {*}
                 * @private
                 */
                _doGetSymbol:function(data,config,defaultSymbol){
                    var labelCfg=config.label;
                    var symbol=config.symbol||defaultSymbol;
                    if(labelCfg&&labelCfg.enable){
                        var opts=labelCfg.options||{};
                        opts.text=this._getLabelText(data,labelCfg.textFormat);
                        var textSymbol=this._createSymbol('TextSymbol',opts);
                        //
                        var symbols={
                            textSymbol:textSymbol
                        };
                        if(symbol instanceof g2.sfs.SimpleMarkerSymbol||symbol instanceof g2.sfs.PictureMarkerSymbol){
                            symbols.markerSymbol=symbol;
                        }else if(symbol instanceof g2.sfs.SimpleLineSymbol){
                            symbols.lineSymbol=symbol;
                        }else if(symbol instanceof g2.sfs.SimpleFillSymbol){
                            symbols.fillSymbol=symbol;
                        }
                        var currencySymbol = new g2.sfs.CurrencySymbol(symbols);
                        return currencySymbol;
                    }
                    return symbol;
                },

                /***
                 * 符号改变时调用的方法
                 * @private
                 */
                _onSymbolsUpdated:function(){
                    if(!this._invokeSymbolUpdateCallback){
                        return;
                    }
                    var elements;
                    elements=this.layer.elements;
                    var k=0,len=elements.length,
                        arr=[];
                    for(;k<len;k++){
                        var ele=elements[k],
                            symbolKey=ele._symbolKey;
                        if(symbolKey){
                            var existsObj=this._getSymbolObj(symbolKey,arr);
                            if(existsObj){
                                continue;
                            }
                            var symbolObj=this._getSymbolObj(symbolKey,this.allSymbols);
                            arr.push(symbolObj);
                        }
                    }
                    //
                    //clear current
                    this.currentSymbols=null;
                    this.currentSymbols=arr;
                    //invoke callback
                    this.invokeCallback('symbolUpdateCallback',{
                        layerId:this.options.layerId,
                        symbols:arr
                    });
                },
                /***
                 * 图层内容变化的回调
                 * @private
                 */
                _onElementChanged:function(){
                    var array=this.elements||this.features,
                        geometryArr=[];
                    // console.log('element changed :'+array.length);
                    if(array.length==0){
                        this._currentExtent=[NaN,NaN,NaN,NaN];
                    }else{
                        for(var i=0,len=array.length;i<len;i++){
                            var ele=array[i];
                            if(ele&&ele.geometry){
                                geometryArr.push(ele.geometry);
                            }
                        }
                        var envelope=G.utils.GeometryUtil.getGeometryEnvlop(geometryArr);
                        this._currentExtent=this._envelopeFromGeom(envelope);
                    }
                },
                /***
                 * 在valueCfg对象中找到值对应的配置
                 * @param data
                 * @param renderer
                 * @private
                 */
                _fetchSymbolConfig:function(data,renderer){
                    if(!renderer){
                        return null;
                    }
                    //比例尺在最深的渲染器
                    if(renderer.type=='zoomLevel'){
                        return renderer;
                    }
                    //
                    var valueCfg=renderer.values,key,value=eval('data.'+renderer.field);
                    for(key in valueCfg){
                        if(CommonUtil.assertWithin(value,key)){
                            var cfg=valueCfg[key];
                            if(cfg.renderer){
                                return this._fetchSymbolConfig(data,cfg.renderer);
                            }else{
                                return cfg;
                            }
                        }
                    }
                    return null;
                },
                /***
                 * 根据格式获取标注文本
                 * @param data
                 * @param textFormat
                 * @private
                 */
                _getLabelText:function(data,textFormat){
                    if(!textFormat){
                        return '';
                    }
                    var phReg=/(\$\{[\w\_\-\d]{0,}\})/g,
                        attrReg=/([\w\_\-\d]+)/g;
                    var phArr=textFormat.match(phReg),text=textFormat;
                    if(phArr&&phArr.length>0){
                        for(var i=0,len=phArr.length;i<len;i++){
                            var placeHolder=phArr[i],replace='';
                            var attrArr=placeHolder.match(attrReg);
                            if(attrArr&&attrArr.length==1){
                                replace=data[attrArr[0]]||'';
                            }
                            text=text.replace(placeHolder,replace);
                        }
                    }
                    return text;
                }

            });
        },
        //查找要素相关方法集合
        includeFindElementById:function(component){
            component.include({
                _getElementLayerById:function(layer,id){
                    var element=layer.find(id);
                    var obj=undefined;
                    if (element!=undefined){
                        obj= {
                            element:element,
                            layer:layer
                        };
                    };
                    return obj;
                },
                _getGroupLayerLayerById:function(layer,id){
                    var layers=layer.groupLayers;
                    for(var k in layers){
                        var object=this._getLayerElementById(layers[k],id);
                        if(object){
                            return object;
                        }
                    }
                    return object;
                },
                _getFeatureLayerById:function(layer,id){
                    var features =layer.features;
                    var obj=undefined;
                    for(var k=0,len=features.length;k<len;k++){
                        var feature=features[k];
                        if(feature&&feature.objectId==id){
                            return {
                                element:feature,
                                layer:layer
                            };
                        }
                    }
                    return obj;
                },
                /***
                 * 根据id从layer中获取元素和图层对象；
                 * @param layer
                 * @param id
                 * @returns {*}
                 * @private
                 */
                _getLayerElementById:function(layer,id){
                    var obj=undefined;
                    if(layer instanceof g2.carto.ElementLayer||
                        layer instanceof g2.carto.ClusterLayer){
                        obj=this._getElementLayerById(layer,id);
                    }else if(layer instanceof g2.carto.GroupLayer){
                        obj=this._getGroupLayerLayerById(layer,id);
                    }else if(layer instanceof g2.carto.FeatureLayer){
                        obj=this._getFeatureLayerById(layer,id);
                    }else{
                        LoggerUtil.error("Unkown Type layer!!!");
                        LoggerUtil.error(layer,id);
                    }
                    return obj;
                },
            });
        },

        includeParseSymbolCfg:function(component){
            component.include({
                /***
                 * 根据符号的key 获取符号配置对象
                 * @param symbolKey 符号的key
                 * @param symbols 符号数组；如果不传，则从默认为当前图层的所有符号数据；
                 * @private
                 */
                _getSymbolObj:function(symbolKey,symbols){
                    var _symbols=symbols||this.allSymbols;
                    var i=0,len=_symbols.length;
                    for(;i<len;i++){
                        var obj=_symbols[i];
                        if(obj&&obj.symbolKey==symbolKey){
                            return obj;
                        }
                    }
                    return null;
                },

                //获取配置;如果已指定；则不根据配置路径请求；
                _getSymbolCfg:function(callback,context){
                    if(!this.symbolConfig){//读取符号配置
                        CommonUtil.ajaxGet({
                            url:this.options.symbolConfigUrl,
                            dataType:'json',
                            async:false
                        },function(cfg){
                            this._parseSymbolCfg(cfg);
                            CommonUtil.isFunction(callback)&&callback.call(context||window,cfg);
                        },this);
                    }else{
                        this._parseSymbolCfg(this.symbolConfig);
                        CommonUtil.isFunction(callback)&&
                        callback.call(context||window,this.symbolConfig)
                    }
                },

                /***
                 * 设置验证过的SymOpts.Source
                 * @param symOpts
                 * @private
                 */
                _setValid_SymOptsSource:function(symOpts){
                    if(symOpts&&symOpts.sourceKey&&!symOpts.source){
                        symOpts.source='';
                    }
                },
                /***
                 * 返回验证好的数据对象
                 * @param data
                 * @returns {*}
                 * @private
                 */
                _getValidObj:function(data){
                    if (data==undefined){
                        return {};
                    }
                    return data;
                },
                /***
                 * 解析符号配置
                 * @param cfg
                 * @private
                 */
                _parseSymbolCfg:function(cfg){
                    var selfObj=this;
                    if(!cfg){
                        return;
                    }
                    //清除
                    this.symbolConfig=null;
                    delete this.symbolConfig;
                    this.symbolConfig_=null;
                    delete this.symbolConfig_;
                    //保存原始的配置
                    this.symbolConfig_=jQuery.extend(true,{},cfg);
                    //默认符号
                    var defaultSym=this._getValidObj(cfg.default);//var defaultSym=cfg.default||{};
                    if(defaultSym.type&&defaultSym.options){
                        cfg.defaultSymbol=this._createSymbol(defaultSym.type,defaultSym.options);
                    }
                    //默认标注
                    var tmpLabel=this._getValidObj(cfg.label);
                    cfg.label=jQuery.extend(true,{
                        enable:false,//false表示无标注
                        options:{},
                        textFormat:''
                    },tmpLabel);
                    //渲染的字段，和可能的值；按顺序存储；
                    this.renderFields=[];
                    //保存所有的符号key值和符号；
                    var allSymbols=[{
                        symbolKey:this.options.defaultSymbolKey,//默认符号的key值；
                        title:cfg.title,
                        symbol:cfg.defaultSymbol,
                        label:cfg.label
                    }];
                    this.allSymbols=allSymbols;
                    //
                    _handlerRenderer(cfg,cfg,'',this._createSymbol,this.renderFields,this);
                    //保存符号配置
                    this.symbolConfig=cfg;
                    /***
                     * 递归处理配置
                     * @param _cfg
                     * @param cfg
                     * @param symbolKey
                     * @param createSymFn
                     * @param context
                     * @returns {boolean}
                     * @private
                     */
                    function _handlerRenderer(_cfg,cfg,symbolKey,createSymFn,renderFields,context){
                        var obj=_cfg.renderer;
                        if(!obj){
                            return false;
                        }
                        /***
                         * 根据比例尺渲染
                         */
                        if(obj['type']=='zoomLevel'){
                            cfg.renderZoom=true;
                            symbolKey+='zoomLevel$=$';
                        }else{//根据字段渲染
                            var renderField=obj['field'];
                            ensureFieldUnique(renderFields,obj);
                            symbolKey+=''+renderField+'$=$';
                        }
                        var key;
                        //渲染的值
                        var renderValues=obj['values'];
                        for(key in renderValues){
                            var obj0=renderValues[key];
                            var mySymbolKey=symbolKey;
                            mySymbolKey+=key+'$_$';
                            if(obj0.renderer){//渲染器节点
                                _handlerRenderer(obj0,cfg,mySymbolKey,createSymFn,renderFields,context);
                            }else{//符号节点
                                var symCfg=jQuery.extend(true,{},cfg.default);
                                //obj0.symbol=obj0.symbol||{};
                                obj0.symbol=selfObj._getValidObj(obj0.symbol);
                                var symOpts=obj0.symbol.options;
                                selfObj._setValid_SymOptsSource(symOpts);
                                symCfg=jQuery.extend(true,symCfg,obj0.symbol);
                                //获取符号对象
                                obj0.symbol=createSymFn.call(context,symCfg.type,symCfg.options);
                                //保存每个符号的标题；符号的key值；
                                obj0.title=obj0.title||_cfg.title;
                                obj0.symbolKey=mySymbolKey.substr(0,mySymbolKey.length-3);
                                //不使用标注
                                if(!cfg.label.enable){
                                    obj0.label=false;
                                }else if(obj0.label===false){//手动设置false不渲染
                                }else{//使用标注，保存标注的样式配置；
                                    var label=jQuery.extend(true,{},cfg.label);
                                    obj0.label=selfObj._getValidObj(obj0.label);
                                    label=jQuery.extend(true,label,obj0.label);
                                    obj0.label=label;
                                }
                                //保存每个符号的标题；符号的key值；
                                allSymbols.push({
                                    symbolKey:obj0.symbolKey,
                                    title:obj0.title,
                                    symbol:obj0.symbol,
                                    label:obj0.label
                                });
                            }
                        }
                        return true;
                    }
                    //提取字段名和字段值
                    function ensureFieldUnique(fields,cfg){
                        var k=0,len=fields.length;
                        for(;k<len;k++){
                            var field=fields[k];
                            if(field&&field.field==cfg.field){
                                return;
                            }
                        }
                        //
                        var values=[],vals=cfg.values||{};
                        for(var k in vals){
                            var regVal=null;
                            try{
                                var reg=eval(k);
                                if(reg instanceof RegExp){
                                    regVal=reg;
                                }
                            }catch(e){}
                            values.push(regVal||k);
                        }
                        var field={
                            field:cfg.field,
                            values:values
                        };
                        fields.push(field);
                    }
                },
            });
        },

        includeGenerateNewSymbol:function(component){
            component.include({
                _getIconSource:function (sourceKey){
                    if(sourceKey){
                        if(sourceKey.indexOf('.')<0){
                            return  G.icons[sourceKey];
                        }else{
                            return G.utils.CommonUtil.getValByVarPath(sourceKey);
                        }
                    }
                },
                /***
                 * 根据符号和配置生成新的符号
                 * @param symbol
                 * @param config
                 * @private
                 */
                _generateNewSymbol:function(symbol,config){
                    var sym=null,
                        options={};
                    var symbolType=symbol.$type.split(',')[0];
                    var selfObj=this;

                    /***
                     * 根据符号类型获取缺省符号配置对象
                     * @param type
                     * @param config
                     * @returns {*|{}}
                     * @private
                     */
                    function _getConfig(type,config){
                        var symConfig=null;
                        if(CommonUtil.isObject(config)){
                            if(type==config.type){
                                symConfig=config;
                            }
                        }else if(CommonUtil.isArray(config)){
                            for(var k=0,len=config.length;k<len;k++){
                                var cfg=config[k];
                                if(cfg&&cfg.type==type){
                                    symConfig=cfg;
                                    break;
                                }
                            }
                        }
                        return symConfig||{};
                    };

                    function _setNewSymbol(symModel,config){
                        var newSym;
                        if(symModel){
                            newSym=selfObj._generateNewSymbol(symModel,config);
                        }
                        return newSym;
                    };
                    var symConfig=_getConfig(symbolType,config);
                    jQuery.extend(true,options,symConfig.options||{});
                    var getNewSymbol={
                        'PictureMarkerSymbol':function(){
                            var sourceKey=symbol['sourceKey']+'_hl';//高亮特效
                            options.source=selfObj._getIconSource(sourceKey);
                            return selfObj._createSymbol(symbolType,options);
                        },
                        'SimpleMarkerSymbol':function(){
                            return selfObj._createSymbol(symbolType,options);
                        },
                        'SimpleLineSymbol':function(){
                            return selfObj._createSymbol(symbolType,options);
                        },
                        'SimpleFillSymbol':function(){
                            return selfObj._createSymbol(symbolType,options);
                        },
                        'CurrencySymbol':function(){
                            var fillSym=symbol.fillSymbol||null,
                                markerSym=symbol.markerSymbol||null,
                                textSym=symbol.textSymbol||null,
                                nFillSym,nMarkerSym,nTextSym;
                            nFillSym=_setNewSymbol(fillSym,config);
                            nMarkerSym=_setNewSymbol(markerSym,config);
                            nTextSym=_setNewSymbol(textSym,config);
                            var sym=new g2.sfs.CurrencySymbol({
                                fillSymbol:nFillSym,
                                markerSymbol:nMarkerSym,
                                textSymbol:nTextSym
                            });
                            return sym;
                        }
                    }
                    if (typeof getNewSymbol[symbolType]==="function"){
                        sym=getNewSymbol[symbolType]();
                    }
                    return sym;
                }
            });
        },

    };
    return extend;
});
